<nav class="step-breadcrumb">
    <ng-container *ngFor="let item of breadcrumbs; let last = last; let i = index">
        <span class="breadcrumb-item" [class.active]="i === activeIndex" [class.clickable]="isClickable(i)"
            [class.disabled]="!isClickable(i) && i !== activeIndex"
            (click)="isClickable(i) && onBreadcrumbClick(item, i)">
            <po-icon *ngIf="item.icon" [p-icon]="item.icon"></po-icon>
            {{ item.label }}
        </span>

        <span *ngIf="!last"
            class="breadcrumb-separator an an-caret-right po-breadcrumb-icon-arrow po-fonts-icon"></span>
    </ng-container>
</nav>